'use strict';

/**
 * Base class for a LayoutView
 *
 * @category   Model
 * @module     base
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var Marionette = require('backbone-marionette');
var ItemView = require('base/Colido.ItemView');

var LayoutView = Marionette.LayoutView.extend({
    viewData: {},

    constructor: function() {
        Marionette.LayoutView.prototype.constructor.apply(this, arguments);

        this.listenTo(App.vent, 'resizeThrottled', function() { this.triggerMethod('resize'); }.bind(this));
    },

    initialize: function(options) {
        if (options) {
            _.extend(this.viewData, options.viewData);
        }

        this.on('render', function(view){
            if (_.isFunction(this.options.onRender)) {
                this.options.onRender(view);
            }
        })

        this.on('show', function(view){
            if (_.isFunction(this.options.onShow)) {
                this.options.onShow(view);
            }
        })

        this.on('attach', function(view){
            if (_.isFunction(this.options.onAttach)) {
                this.options.onAttach(view);
            }
        })
    },

    serializeData: function() {
        return ItemView.prototype.serializeData.apply(this, arguments);
    },
});

module.exports = LayoutView;